import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useReducer, useEffect } from 'react';
var initialOperativeSystemState = {
  isIos: false,
  isAndroid: false,
  isHuawei: false,
  isMobileOS: false,
  currentOS: ''
};

var OperativeSystemReducer = function OperativeSystemReducer(state, action) {
  switch (action.type) {
    case 'ios':
      return Object.assign(Object.assign({}, state), {
        isIos: action.state,
        currentOS: 'ios'
      });

    case 'android':
      return Object.assign(Object.assign({}, state), {
        isAndroid: action.state,
        currentOS: 'android'
      });

    case 'huawei':
      return Object.assign(Object.assign({}, state), {
        isHuawei: action.state,
        currentOS: 'huawei'
      });

    case 'isMobileOS':
      return Object.assign(Object.assign({}, state), {
        isMobileOS: action.state
      });

    default:
      return state;
  }
};

export var useOperativeSystem = function useOperativeSystem() {
  var _useReducer = useReducer(OperativeSystemReducer, initialOperativeSystemState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var windowUserAgent = window.navigator.userAgent.toLowerCase();

  var setOperativeSystem = function setOperativeSystem() {
    var isIos = windowUserAgent.indexOf('iphone') > 1 || windowUserAgent.indexOf('ipad') > 1;
    if (isIos) dispatch({
      type: 'ios',
      state: isIos
    });
    var isAndroid = windowUserAgent.indexOf('android') > 1;
    if (isAndroid) dispatch({
      type: 'android',
      state: isAndroid
    });
    var isHuawei = windowUserAgent.indexOf('huawei') > 1;
    if (isHuawei) dispatch({
      type: 'huawei',
      state: isHuawei
    });
    dispatch({
      type: 'isMobileOS',
      state: isIos || isAndroid || isHuawei
    });
  };

  useEffect(function () {
    setOperativeSystem(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return Object.assign({}, state);
};